<template>
  <div
    class="px-6 pt-6 rounded-lg bg-cardColor shadow-md transition duration-300"
    :class="[
      { 'hover:scale-105': scale },
      addClass,
      { 'bg-gray-300': selected },
    ]"
  >
    <div
      class="flex justify-end -mt-4 -mr-4 cursor-pointer"
      @click="$emit('onClose')"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-5 h-5"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M6 18 18 6M6 6l12 12"
        />
      </svg>
    </div>

    <slot />
  </div>
</template>

<script>
export default {
  props: {
    scale: {
      type: Boolean,
      default: false,
    },
    addClass: [Array, String],
    selected: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
